module.exports = __webpack_public_path__ + "static/media/University_of_Sunderland_logo.e0e826ef.png";